module.exports = __webpack_public_path__ + "img/Creative_Partners.75e688b1.jpg";